import script from "./CheckoutThankyou.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutThankyou.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutThankyou.vue?vue&type=style&index=0&id=4e8c9388&scoped=true&lang=css"

import exportComponent from "/media/alexandre/08eeec93-1efa-4ec5-9b9c-83fb7789c963/Projects/uniboi-app-2023/uniboi-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8c9388"]])

export default __exports__